__turbopack_context__.v({
  "CoverSelectionBtnWrapper": "F_OPuq_CoverSelectionBtnWrapper",
  "focus_class": "F_OPuq_focus_class",
  "icon_btn_secondary": "F_OPuq_icon_btn_secondary",
  "icon_btn_secondary_dark": "F_OPuq_icon_btn_secondary_dark",
  "label_button_active": "F_OPuq_label_button_active",
  "left_Icon_margin": "F_OPuq_left_Icon_margin",
  "primary": "F_OPuq_primary",
  "primary_left_icon": "F_OPuq_primary_left_icon",
  "right_Icon_margin": "F_OPuq_right_Icon_margin",
  "secondary": "F_OPuq_secondary",
  "secondary_left_icon": "F_OPuq_secondary_left_icon",
  "tertiary_dark": "F_OPuq_tertiary_dark",
  "tertiary_light": "F_OPuq_tertiary_light",
  "tertiary_light_error": "F_OPuq_tertiary_light_error",
  "tertiary_light_icon": "F_OPuq_tertiary_light_icon",
});
